import {defineAsyncComponent} from 'vue';

const chooseFinanceReportSetting = defineAsyncComponent(() =>
  import('@/views/system/financeReportSetting/ChooseFinanceReportSetting.vue'),
);
const financeReportSetting_15QTDA = defineAsyncComponent(() =>
  import('@/views/system/financeReportSetting/FinanceReportSetting_15QTDA.vue'),
);

const financeReportSetting = defineAsyncComponent(() =>
  import('@/views/system/financeReportSetting/FinanceReportSetting.vue'),
);

export function registerFr(app) {
  app.component('ChooseFinanceReportSetting', chooseFinanceReportSetting);
  app.component('FinanceReportSetting15QTDA', financeReportSetting_15QTDA);
  app.component('FinanceReportSetting', financeReportSetting);
}
